import { IUserDetailsDTO } from '../../api/users.dao';

/**
 * Entity, which holds active session token, supposed to be used for communications with server
 * Responsible for obtaining the session token from either external source or internal persistent storage
 */
abstract class IAuthAggregate {
    /**
     * return current auth status as boolean value
     */
    public abstract isAuthenticated() : boolean;

    public abstract isPermissionAvailable(): boolean;

    /**
     * perform authentication in implementation-specific way in order to obtain session token
     * return the indication of whether the auth action was successfull or not
     */
    public abstract authenticate() : Promise<void>;

    public abstract getSessionToken(): Promise<string>;

    public abstract getUserPermissions(): Promise<void>;

    public abstract getCurrentUser(): Promise<IUserDetailsDTO>;

    /**
     * perform logout and mandatary post-logout actions, specific for particular auth provider
     */
    public abstract logout() : Promise<void>;

    public abstract exchangeRefreshTokenForAccessToken(): Promise<void>;

    public abstract initialize(): Promise<void>;
}

export { IAuthAggregate };
